import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.PeFundNumberEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    peFundNumberEnumList: { items: data, total },
  } = await sdk.getListPeFundNumberEnum(
    filterSortPage({ filter, sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { peFundNumberEnum: data } = await sdk.getOnePeFundNumberEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { peFundNumberEnumMany: data } = await sdk.getManyPeFundNumberEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const peFundNumberEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
